import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import * as moment from 'moment';

export interface Nps {
  email: string;
  external_id: number;
  account_token: string;
  properties: NpsProperty[];
}

export interface NpsProperty {
  course_name: string;
}

@Component({
  selector: 'nps-loader',
  standalone: true,
  imports: [CommonModule],
  template: '',
})
export class NPSLoaderComponent {
  loadWootric(nps: Nps): void {
    // Überprüfen, ob das Wootric-Skript bereits geladen ist
    if (!document.getElementById('wootric-sdk')) {
      // Wootric-Skript laden
      const script = document.createElement('script');
      script.id = 'wootric-sdk';
      script.type = 'text/javascript';
      script.src = 'https://cdn.wootric.com/wootric-sdk.js';
      script.onload = () => {
        // Konfigurationscode ausführen, nachdem das Skript geladen wurde
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (window as any).wootric_survey_immediately = true;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (window as any)['wootricSettings'] = {
          email: nps.email,
          created_at: moment().unix(),
          account_token: nps.account_token,
          external_id: nps.external_id,
          properties: nps.properties,
        };

        // Umfrage anfordern
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (window as any)['wootric']('run');
      };
      document.head.appendChild(script);
    } else {
      // Skript ist bereits geladen, nur die Umfrage anfordern
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (window as any).wootric_survey_immediately = true;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (window as any)['wootricSettings'] = {
        email: nps.email,
        created_at: moment().unix(),
        account_token: nps.account_token,
        external_id: nps.external_id,
        properties: nps.properties,
      };
      // Umfrage anfordern
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (window as any)['wootric']('run');
    }
  }
}
